export const PHONE = "(949) 371-5993";
export const PHONE_HREF = "tel:+19493715993";
export const ADDRESS = "21 Alexandria, Irvine, CA 92614";
export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_841c976d-1a4d-41bb-942f-896ed7e0dfb7/artifacts/twq7r2ni_26904fc889e7696e964abe1795fb736b_1200_80.webp";

export const BRANDS = [
  "Bradford White",
  "Rheem",
  "AO Smith",
  "Navien",
  "Rinnai",
  "Noritz",
  "Takagi",
  "State",
  "Bosch",
];

export const NEIGHBORHOODS = [
  "Woodbridge",
  "University Park",
  "Woodbury",
  "Portola Springs",
  "Orchard Hills",
  "Turtle Rock",
  "Quail Hill",
  "Northwood",
  "Westpark",
  "Oak Creek",
  "Cypress Village",
  "Great Park",
];

export const NEARBY_CITIES = [
  "Tustin",
  "Lake Forest",
  "Costa Mesa",
  "Newport Beach",
  "Laguna Hills",
  "Mission Viejo",
  "Santa Ana",
  "Aliso Viejo",
];

export const REVIEWS = [
  {
    name: "Karen M.",
    area: "Woodbridge, Irvine",
    rating: 5,
    text: "Our tank started leaking on a Sunday night. They picked up the phone at 9pm, walked us through shutting off the water, and had a new Bradford White installed by noon the next day. Hot water back in under 24 hours.",
    service: "Emergency Tank Replacement",
  },
  {
    name: "David T.",
    area: "Turtle Rock, Irvine",
    rating: 5,
    text: "Converted our old 50-gallon tank to a Navien tankless. Quoted a fair, flat price up front — no surprises on the invoice. The install was clean, permitted, and the tech explained the whole system before leaving.",
    service: "Tankless Conversion",
  },
  {
    name: "Priya S.",
    area: "Woodbury, Irvine",
    rating: 5,
    text: "Pilot light kept going out on our gas heater. Two other companies said 'just replace it.' These guys diagnosed a bad thermocouple and fixed it for a fraction of a replacement. Honest work is rare — found it here.",
    service: "Water Heater Repair",
  },
  {
    name: "Mike R.",
    area: "Portola Springs, Irvine",
    rating: 5,
    text: "Same-day replacement, exactly as advertised. Called at 8am with no hot water, new Rheem running by 3pm. Hauled away the old unit, left the garage cleaner than they found it.",
    service: "Same-Day Replacement",
  },
  {
    name: "Linda C.",
    area: "Tustin",
    rating: 5,
    text: "They serviced our tankless unit and descaled it — hot water is noticeably faster now. Booked online, got a confirmation call, tech showed up in the window. Professional from start to finish.",
    service: "Tankless Maintenance",
  },
  {
    name: "James H.",
    area: "Quail Hill, Irvine",
    rating: 5,
    text: "Upfront pricing over the phone, and the final bill matched the quote to the dollar. Replaced our electric water heater and upgraded the earthquake straps to code. These are the water heater guys in Irvine.",
    service: "Electric Water Heater",
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1568321431819-bb00accbca4a?auto=format&fit=crop&w=2000&q=80",
  plumberHands:
    "https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg?auto=compress&w=1200",
  plumberCabinet:
    "https://images.unsplash.com/photo-1676210133055-eab6ef033ce3?auto=format&fit=crop&w=1200&q=80",
  bathroom:
    "https://images.pexels.com/photos/12196323/pexels-photo-12196323.jpeg?auto=compress&w=1200",
  technician:
    "https://images.unsplash.com/photo-1707897283701-40d6f55b8738?auto=format&fit=crop&w=1200&q=80",
  van: "https://images.pexels.com/photos/30346769/pexels-photo-30346769.jpeg?auto=compress&w=1200",
};

export const ISSUE_OPTIONS = [
  "No hot water",
  "Water heater leaking",
  "Not enough hot water",
  "Strange noises / rumbling",
  "Pilot light won't stay lit",
  "New installation quote",
  "Tankless conversion quote",
  "Other plumbing issue",
];
